import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicNavbar from '../components/public/PublicNavbar';
import PublicFooter from '../components/public/PublicFooter';

const PublicLayout = ({ onLoginClick }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <PublicNavbar onLoginClick={onLoginClick} />
      <main style={{ flex: 1 }}>
        <Outlet context={{ onLoginClick }} />
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
